<script lang="ts" setup>
  import InfoIcon from '@/assets/icons/info.svg';
  import { getDocLink } from '@/docLinks';
  import type { VDocLinkProps } from './types';

  const props = defineProps<VDocLinkProps>();

  const { locale, t } = useI18n({
    messages: {
      ru: { newTab: '{name}. Откроется в новой вкладке' },
      en: { newTab: '{name}. Opens in a new tab' },
    },
  });

  const link = computed(() => getDocLink(props.place, locale.value));
</script>

<template>
  <a
    v-if="link"
    v-tooltip.bottom="link.label"
    :href="link.url"
    target="_blank"
    rel="noopener noreferrer"
    class="inline-flex items-center justify-center align-middle flex-none w-24 h-24 rounded text-gray-muted transition-colors hover:text-gray-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue"
    :aria-label="t('newTab', { name: link.label })"
    data-testid="docLink">
    <InfoIcon class="w-[22px] h-[22px]" />
  </a>
</template>
